import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../../utils/common.constants';

@Injectable()
export class UpDatesService { 
  constructor(private http: HttpClient) {
  }
 
  saveNotes(data): Observable<any> {
    return this.http.post(CommonConstants.env +'api/medicalFile/notes', data).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveOpdCare(data): Observable<any> {
    return this.http.post(CommonConstants.env +'api/medicalFile/opd/cares', data).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveConsultation(data): Observable<any> {
    return this.http.post(CommonConstants.env +'api/medicalFile/consultation', data).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getFileData(fileId, services): Observable<any> {
    return this.http.get(CommonConstants.env +'api/medicalFile/' + fileId + '?services=' + services.toString()).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  errorHandler(error: any): void {
    throwError(error);
  };

}